module.exports = __webpack_public_path__ + "img/banner_bg.09980dde.png";